// extracted by mini-css-extract-plugin
export default {"badge":"AiGeneratedBadge_badge__izPEj"};